
































	// @ts-ignore
    import _ from './CImgRatio.ts'; export default _;
